import React from "react";
import { InspectionTypeMap } from "../../utils/enums";

const DriverNotes = ({ inspectionType, notes }) => {
  return (
    <div className="section-container">
      <div className="section-header">Driver Notes</div>

      <div className="info-box">
        <div>
          {notes ||
            `No notes provided by driver at ${InspectionTypeMap[
              inspectionType
            ].toLowerCase()}.`}
        </div>
      </div>
    </div>
  );
};

export default DriverNotes;
